import { ReactNode, useCallback, useEffect, useMemo, useState } from 'react';
import { Context } from './ReferralContext';
import { initialReferralForm, ReferralFormData } from './ReferralData';
import { initialProData, ProData } from '../../../shared/types';

function ReferralContextProvider({
  children
}: Readonly<{ children: ReactNode }>) {
  const [referral, setReferral] = useState(initialReferralForm);
  const [proInfo, setProInfo] = useState(initialProData());
  const [phoneVerificationCountDown, setPhoneVerificationCountDown] =
    useState(0);
  const [startTimer, setStartTimer] = useState(false);
  const [isProTrackingStatuses, setIsProTrackingStatuses] = useState(false);

  const updateReferral = useCallback((update: Partial<ReferralFormData>) => {
    setReferral((prevReferral) => ({
      ...prevReferral,
      ...update
    }));
  }, []);

  function updatePhoneVerificationCountDown(countDown: number) {
    setPhoneVerificationCountDown(countDown);
    setStartTimer(true);
  }

  // Timer countdown that sets the number each second.
  useEffect(() => {
    if (!startTimer || phoneVerificationCountDown === 0) {
      return;
    }

    // Start the countdown
    const myInterval = setInterval(() => {
      setPhoneVerificationCountDown((prevCountDown) => {
        if (prevCountDown > 1) {
          return prevCountDown - 1;
        } else {
          clearInterval(myInterval);
          setStartTimer(false);
          return 0;
        }
      });
    }, 1000);

    return () => clearInterval(myInterval);
  }, [startTimer, phoneVerificationCountDown]);

  const updateProInfo = useCallback((proInfo: ProData) => {
    setProInfo(proInfo);
  }, []);

  const referralContextObject = useMemo(() => {
    return {
      referral,
      updateReferral,
      proInfo,
      updateProInfo,
      phoneVerificationCountDown,
      updatePhoneVerificationCountDown,
      isProTrackingStatuses,
      setIsProTrackingStatuses
    };
  }, [
    referral,
    updateReferral,
    proInfo,
    updateProInfo,
    phoneVerificationCountDown,
    isProTrackingStatuses
  ]);
  return (
    <Context.Provider value={referralContextObject}>
      {children}
    </Context.Provider>
  );
}

export { ReferralContextProvider };
